<div class="container-background container-fluid content">
  <div class="row">
    <h2 class="page-title col-12">Mon compte</h2>
  </div>
  <div class="m-2 p-4 bg-white rounded">
    @if (form) {
      <form [formGroup]="form" (ngSubmit)="save()">
        <div class="row">
          <div class="col-12 d-flex justify-content-center mb-4">
            <app-circle-image-input [src]="$safeNavigationMigration(image?.current)" defaultSrc="assets-front/images/avatar-default.png" (update)="updateImage($event)" (delete)="deleteImage($event)"></app-circle-image-input>
          </div>
        </div>
        <fieldset>
          <legend>Données générales</legend>
          <div class="row">
            @if (form.get('genre'); as control) {
              <div class="mb-3 col-12 col-lg-6">
                <label for="genre">Civilité *</label>
                <select class="form-control" id="genre" formControlName="genre" [ngClass]="{'is-invalid': !control.valid}">
                  <option></option>
                  @for (item of $safeNavigationMigration(referentiels?.genre) | keyvalue; track item) {
                    <option [value]="item.key">{{item.value}}</option>
                  }
                </select>
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
            @if (form.get('prenom'); as control) {
              <div class="mb-3 col-12 col-lg-6">
                <label for="prenom">Prénom *</label>
                <input class="form-control" id="prenom" type="text" formControlName="prenom" placeholder="Votre prénom" [ngClass]="{'is-invalid': !control.valid}"/>
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
            @if (form.get('nom'); as control) {
              <div class="mb-3 col-12 col-lg-6">
                <label for="nom">Nom *</label>
                <input class="form-control" id="nom" type="text" formControlName="nom" placeholder="Votre nom" [ngClass]="{'is-invalid': !control.valid}"/>
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
            @if (form.get('adresseEmail'); as control) {
              <div class="mb-3 col-12 col-lg-6">
                <label for="email">Email *</label>
                <input class="form-control" id="email" type="email" formControlName="adresseEmail" placeholder="Votre email" [ngClass]="{'is-invalid': !control.valid}"/>
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
          </div>
        </fieldset>
        <fieldset formGroupName="plainPassword">
          <legend>Mot de passe</legend>
          <div class="row">
            @if (form.get('plainPassword.first'); as control) {
              <div class="mb-3 col-12 col-lg-6">
                <label for="plainPassword-first">Mot de passe</label>
                <input class="form-control" id="plainPassword-first" type="password" formControlName="first" placeholder="Nouveau mot de passe" autocomplete="false" [ngClass]="{'is-invalid': !control.valid}"/>
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
            @if (form.get('plainPassword.second'); as control) {
              <div class="mb-3 col-12 col-lg-6">
                <label for="plainPassword-second">Confirmation</label>
                <input class="form-control" id="plainPassword-second" type="password" formControlName="second" placeholder="Confirmation" autocomplete="false" [ngClass]="{'is-invalid': !control.valid}"/>
                <div class="invalid-feedback">{{ control.errors }}</div>
              </div>
            }
          </div>
        </fieldset>
        <fieldset>
          <legend>Adresse</legend>
          <app-adresse #adresseComponent formControlName="adresse"></app-adresse>
        </fieldset>
        <fieldset>
          <legend>Paramétrage des notifications</legend>
          <div class="text-center">
            <a class="btn btn-blue" routerLink="/notifications/parametrage">Accéder au paramétrage des notifications</a>
          </div>
        </fieldset>
        <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-bottom justify-content-center">
          <button type="submit" class="btn btn-blue" [disabled]="loaderService.loading | async">Enregistrer</button>
        </nav>
      </form>
    }
  </div>
</div>

